import {ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import { Component, EventEmitter, forwardRef, OnChanges, Output, SimpleChanges, Directive } from '@angular/core';

@Component({
  selector: 'app-base',
  template: ``,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SyncValidatorComponent)
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => SyncValidatorComponent)
    }
  ]
})
export class SyncValidatorComponent implements ControlValueAccessor, OnChanges {
  public _value = null;
  public validator: (c: FormControl) => any = null;

  @Output()
  change: EventEmitter<any> = new EventEmitter();
  onTouched: any = () => { };

  constructor() { }

  // TODO can it be used in child class, will it be called by Angular?
  ngOnChanges(changes: SimpleChanges) {
    // console.log('ngOnChanges', changes);
  }

  public get value() {
    return this._value;
  }

  public set value(val) {
    this._value = val;
    this.change.next(val);
    this.onTouched();
  }

  // trigger validation manually without changing _value
  triggerValidation() {
    this.change.next(this._value);
    this.onTouched();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  registerOnChange(fn) {
    this.change.subscribe(fn);
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  writeValue(value) {
    if (value !== undefined) {
      this.value = value;
    }
  }
}

@Directive()
export class AsyncValidatorComponent implements ControlValueAccessor {
  public _value = null;

  @Output()
  change: EventEmitter<any> = new EventEmitter();
  onTouched: any = () => { };

  constructor() { }

  public get value() {
    return this._value;
  }

  public set value(val) {
    this._value = val;
    this.change.next(val);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.change.subscribe(fn);
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  writeValue(value) {
    if (value !== undefined) {
      this.value = value;
    }
  }
}
